import {
  type ChangeEvent,
  type ComponentType,
  type ElementType,
  type KeyboardEvent,
  Suspense,
  useState,
} from "react"

import { Button, Center, Flex, Icon, Spacer, Spinner, useDisclosure } from "@chakra-ui/react"
import { FaPlus } from "react-icons/fa"
import SearchField from "./SearchField"

interface NavbarProps {
  type: string
  addAllowed?: boolean
  addModalAs: ComponentType | ElementType
  showSearch?: boolean
  onSearchChange?: (newSearchInput: string) => void
}


const Navbar = ({
  type,
  addAllowed,
  addModalAs,
  showSearch,
  onSearchChange,
}: NavbarProps) => {
  const addModal = useDisclosure()
  const [inputValue, setInputValue] = useState<string>("")

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      if (onSearchChange != null) {
        onSearchChange(inputValue)
      }
    }
  }

  const handleOnClick = () => {
    if (onSearchChange != null) onSearchChange(inputValue)
  }

  const handleClear = () => {
    setInputValue("")
    if (onSearchChange != null) {
      onSearchChange("")
    }
  }

  const AddModal = addModalAs

  return (
    <Flex
      py={8}
      gap={4}
      flexDir={{base: "column", md: "row"}}
      alignItems={{base: "flex-start", md: "unset"}}
    >
      <Button
        variant="primary"
        gap={1}
        fontSize={{ base: "sm", md: "inherit" }}
        onClick={addModal.onOpen}
        disabled={!addAllowed}
      >
        <Icon as={FaPlus} />
        {type} hinzufügen
      </Button>

      {addModal.open &&
        <Suspense fallback={
          <Center
            bg="rgba(0, 0, 0, 0.3)"
            position="fixed"
            top="0"
            left="0"
            width="100vw"
            height="100vh"
            zIndex="10000"
          >
            <Spinner size="lg" color="white" />
          </Center>}
        >
          <AddModal isOpen={addModal.open} onClose={addModal.onClose} />
        </Suspense>
      }

      {showSearch &&
        <>
          <Spacer />
          <SearchField
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onClick={handleOnClick}
            onClear={handleClear}
          />
        </>
      }
    </Flex>
  )
}

export default Navbar
